import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FAQ from '@/components/feature/FAQ';
import { useTranslation } from 'react-i18next';

export default function FAQPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">{t('nav_home')}</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">{t('nav_faq')}</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              {t('faq_title')}
            </h1>
            <p className="text-foreground-600 text-lg">
              {t('articles_subtitle')}
            </p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">
            <FAQ />
          </div>
          <div className="max-w-3xl mx-auto mt-10 text-center">
            <a
              href="/"
              className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              {t('nav_home')}
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}